import getters from './getters';
import actions from './actions';
import mutations from './mutations';
export const state = () => ({
  currentImage: null,
  product: null,
  productInspiration: null,
  productCross: null,
  productComplementary: null,
  productNav: {
    product: null
  },
  variants: []
});
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};